import taxRoutes from './TaxSetup/TaxRoutes'
import React, { lazy } from 'react'
import uomRoutes from './UOMModule/UOMRoutes'
import uomRateRoutes from './UOMExchange/ConversionRatesRoutes'
import TaxSchemeRoutes from './TaxScheme/TaxSchemeRoutes'
import policySettingsRoutes from 'containers/GeneralSettingModule/PolicySettings/PolicySettingsRoutes'

const CommonSettingSubmenu = lazy(() =>
  import('./CommonSettingSubmenu').then(module => ({
    default: module.CommonSettingSubmenu,
  }))
)

const commonSettingsRoute = [
  {
    props: { exact: true, path: '/common-setting' },
    component: <CommonSettingSubmenu />,
  },

  ...taxRoutes,
  ...TaxSchemeRoutes,
  ...uomRoutes,
  ...uomRateRoutes,
  ...policySettingsRoutes,
  // ...billItemRoutes,
]

export default commonSettingsRoute
